import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setPersistence, browserLocalPersistence } from "firebase/auth";
import config from "../../config/appConfig";
import { auth } from "../../firebase";
import ApiRequest from "../../api/ApiRequest";
import { APIUrl } from "../../api/endPoints";
import UserContext from "../../context/AuthContext";
import { useDispatch } from "../../store";
import { setUser, setUserAddress } from "../../store/slices/userSlice";
import useAuth from "../../Hooks/useAuth";
import Loading from "../../components/Loader/Loader";

const AuthMode = ({ children }: any) => {

	const { isLoggedIn, users, isLoading, isGoogleSignInProgress } = useAuth();
	const { setUserDetails, userDetails } = useContext(UserContext);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	useEffect(() => {

		const savedUserDetails = sessionStorage.getItem("userDetails");

		if (savedUserDetails) {

			setUserDetails(JSON.parse(savedUserDetails));
			dispatch(setUser({ user: JSON.parse(savedUserDetails) }));
			dispatch(setUserAddress({ userAddress: JSON.parse(savedUserDetails).userAddress }));

		}

	}, [ dispatch, setUserDetails ]);

	useEffect(() => {

		setPersistence(auth, browserLocalPersistence).catch((error: any) => {

			console.error(error);

		});

	}, []);

	useEffect(() => {

		// Don't redirect to login if we're still loading or processing Google sign-in
		if (isLoading || isGoogleSignInProgress) {

			return;

		}

		if (isLoggedIn && users) {

			if (!userDetails?.userType) {

				ApiRequest("get", APIUrl.getUserInfo).then((response: any) => {

					setUserDetails(response);
					sessionStorage.setItem("userDetails", JSON.stringify(response));
					dispatch(setUser({ user: response }));
					dispatch(setUserAddress({ userAddress: response.userAddress }));

					if (Object.keys(response.userAddress).length === 0 && response?.userAddress?.countryName == "") {
						
						navigate(config.routes.userIntro);

						return;

					}

				}).catch((error: any) => {

					console.error("Error fetching user details:", error);

				});

			}

		} else if (!isLoggedIn && !isLoading && !isGoogleSignInProgress) {

			// Only navigate to login if we're not loading and definitely not logged in
			navigate(config.routes.login, { replace: true });

		}

	}, [
		isLoggedIn, users, userDetails, navigate, setUserDetails, dispatch, isLoading, isGoogleSignInProgress
	]);


	// Show loader during authentication process
	if (isLoading || isGoogleSignInProgress) {

		return <Loading />;

	}

	return isLoggedIn ? children : null;

};

export default AuthMode;